import React, { useEffect } from 'react';
import './modal-exito.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import { IconButton } from '@mui/material';
function ModalExito(props) {
    useEffect(() => {
    }, []);
    return (
        <>
            {props.show ? <div className="w3-modal w3-show modal-exito">
                <div className="w3-modal-content w3-animate-zoom w3-round-large">
                    <div className="w3-row">
                        <div className="w3-col w3-right" style={{ width: '50px' }}>
                            <IconButton aria-label="delete" onClick={props.hide}>
                                &nbsp;<FontAwesomeIcon icon={faTimes} color={'#3A3A3A'} />&nbsp;
                            </IconButton>
                        </div>
                        <div className="w3-rest w3-padding w3-center">
                            {/* <span>{props.edicion.label}</span> */}
                        </div>
                    </div>
                    <div className="w3-padding-large bs-bbox w3-center">
                        <FontAwesomeIcon icon={faCheckCircle} size="3x" color={'#28A745'} />
                        <h3>Hemos recibido tu solicitud, nos comunicaremos contigo a través del correo o número de celular que ingresaste, para guiarte con los siguientes pasos.</h3>
                        <button className="w3-btn w3-theme w3-large w3-round-large" onClick={props.hide}>OK</button><br/><br/>
                    </div>
                </div>
            </div> : null}
        </>
    );
}
export default ModalExito;